module.exports = __webpack_public_path__ + "img/vk-icon.ae0cb548.svg";